import React from 'react';
import { Button} from "carbon-components-react";
import { useFormContext } from 'react-hook-form';
import SubmitButton from '../../components/form_elements/submit-button';
import { EnrollmentType } from '../../components/enums/enrollment-type';

const EnrollmentCell = ({title, buttonName, children, lastColumn, submitting, enrollmentType}) => {
    const {setValue} = useFormContext();

    var classes = "pr-4 sm:pr-8 pb-8 relative";
    if(!lastColumn)
        classes = classes + " border-r border-black border-solid";

    const setEnrollmentType = () => {
        setValue("enrollmentsType", enrollmentType);
    }
    
    return ( 
        <div className={classes}>
            <div className="text-xl mb-4">{title}</div>
            <div className="pb-16">
              {children}
            </div>
            <div className="absolute bottom-0 pb-4">
                {
                    enrollmentType === EnrollmentType.OpenEnrollment ?
                 <SubmitButton  onClick={setEnrollmentType} submitting={submitting}>{buttonName}</SubmitButton>
                 :
                 //<Button disabled={true}>Coming Soon</Button>
                 <SubmitButton  onClick={setEnrollmentType} submitting={submitting}>{buttonName}</SubmitButton>
                
                }
            </div>
        </div>    
    );
}
 
export default EnrollmentCell;